module.exports = __webpack_public_path__ + "img/time6.c267bce2.png";